import { createStore, StoreOptions } from 'vuex'
import VuexPersistence from 'vuex-persist'
import { IRootState } from '@/@types'
import app from './modules/app'
import auth from './modules/auth'
import business from './modules/business'
import coupons from './modules/coupons'
import events from './modules/events'
import featureFlags from './modules/featureFlags'
import priceDetails from './modules/priceDetails'
import products from './modules/products'
import shoppingCart from './modules/shopping-cart'
import subscriptions from './modules/subscriptions'
import recurly from './modules/recurly'

const vuexLocal = new VuexPersistence<IRootState>({
  storage: window.localStorage,
  modules: ['shoppingCart', 'coupons'],
})

const store: StoreOptions<IRootState> = {
  modules: {
    app,
    auth,
    business,
    coupons,
    events,
    featureFlags,
    priceDetails,
    products,
    shoppingCart,
    subscriptions,
    recurly,
  },
  ...(process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'local'
    ? {
        getters: {
          state: (state: IRootState) => state,
        },
      }
    : {}),
  plugins: [vuexLocal.plugin],
}

export default createStore<IRootState>(store)
